import "../../components/Popularity/Popularity.css"
import { useEffect, useState } from "react";
import axios from "axios";
import { END_URL, IMG_URL } from "../../config";

function Popularity() {

    // const popularitydata = data?.length > 0 ? data[0] : null;

    const [popularitydata, setPopularityData] = useState(null);
    const [visible, setVisible] = useState(false);

   useEffect(() => {

        const CACHE_KEY = "archetypal_popularity_cache";

        const cached = localStorage.getItem(CACHE_KEY);

        if (cached) {

            const parsed = JSON.parse(cached);

            setPopularityData(parsed);

            requestAnimationFrame(() => {
                setVisible(true);
            });
        }

        axios
            .get(`${END_URL}/archetypal/popularity`)
            .then((res) => {

                const newData = res.data;

                if (!cached || JSON.stringify(JSON.parse(cached)) !== JSON.stringify(newData)) {

                    localStorage.setItem(CACHE_KEY, JSON.stringify(newData));

                    setPopularityData(newData);

                    requestAnimationFrame(() => {
                        setVisible(true);
                    });
                }

            })
            .catch((err) => {
                console.error(err);
            });

    }, []);

    if (!popularitydata) {

        return (
            <div className="popular">
                <div className="container">
                    <div className="popularity-loader"></div>
                </div>
            </div>
        );
    }


    return (
        
        <div className={`popular popularity-transition ${visible ? "show" : ""}`}>


            <div className="container">

                <div className="row popular-row">

                    <div className="col-12 col-sm-12 col-md-4 ">

                        <div className="popuar-img-div popularity-image">

                            <img loading="lazy" decoding="async" src={`${IMG_URL}/d0/${popularitydata?.personalityimage}`} alt={popularitydata?.personalityimage_alt} />
                        </div>

                    </div>

                    <div className="col-12 col-sm-12 col-md-7 col-lg-7">

                        <div className="popuar-content-div popularity-content">

                            <div className="popular-text-div"
                            
                                dangerouslySetInnerHTML={{ __html: popularitydata?.popularity }}>

                             </div>


                            <div className="popular-cards-div popularity-cards">

                                <div className="popular-card-box1">

                                    <div className="popular-number">
                                        <p>{popularitydata?.numoftests}</p>
                                    </div>

                                    <div className="popular-text">
                                        <p>{popularitydata?.takennum}</p>
                                    </div>
                                </div>

                                <div className="popular-card-box1">
                                    <div className="popular-number">
                                        <p>{popularitydata?.numoftests2}</p>
                                    </div>
                                    <div className="popular-text">
                                        <p>{popularitydata?.takennum2}</p>
                                    </div>
                                </div>

                            {
                                popularitydata?.show_test && (
                                    
                                <div className="popular-card-box1">
                                    <div className="popular-number">
                                        <p>{popularitydata?.numoftests3}</p>
                                    </div>
                                    <div className="popular-text">
                                        <p>{popularitydata?.takennum3}</p>
                                    </div>
                                </div>
                            )}

                            </div>

                        </div>

                    </div>


                </div>

            </div>



        </div>
    )
}

export default Popularity